import type { PropsWithChildren } from 'react';

import { cn } from 'cn';

type P = PropsWithChildren<{
  /** The nesting level (1 = root level) */
  level?: number;
}> &
  ComponentStyling;

/**
 * Container for tree items at a given level.
 * Handles vertical padding based on nesting level.
 */
export function TreeItemGroup({ children, className, level = 1, style }: P) {
  return (
    <ul
      className={cn(
        'w-full',
        {
          'pt-2': level === 1,
          'pt-3': level > 1,
        },
        className,
      )}
      style={style}
    >
      {children}
    </ul>
  );
}
